import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=55dd9352&scoped=true"
import script from "./tags.vue?vue&type=script&lang=js"
export * from "./tags.vue?vue&type=script&lang=js"
import style0 from "./tags.vue?vue&type=style&index=0&id=55dd9352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dd9352",
  null
  
)

export default component.exports